import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('tag_container')),
    style: _normalizeStyle(_ctx.styleTag)
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(_ctx.getClass('tag_text')),
      style: _normalizeStyle(_ctx.styleTagText)
    }, _toDisplayString(_ctx.text), 7 /* TEXT, CLASS, STYLE */)
  ], 6 /* CLASS, STYLE */))
}